import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import UI from '../../components/ExcerciseTypes/Design/UserInterface';
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine';

const json = {

    1: { // Exercise num
        unit: 'Unit 7',
        id: 'WB4-V2-U7-P48-E1',
        audio: '',
        video: '',
        component: DesignUnderLine,
        totalInput: 5,
        exerciseKey: 'img/FriendsPlus/Page48/E1/Key/answerKey.png',
        titleImage: '',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page48/E1/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page48/E1/2.jpg' },
                { url: 'img/FriendsPlus/Page48/E1/3.jpg', input: 1, },
                { url: 'img/FriendsPlus/Page48/E1/4.jpg', input: 2, isCorrect: true },
                { url: 'img/FriendsPlus/Page48/E1/5.jpg', input: 3, },
                { url: 'img/FriendsPlus/Page48/E1/6.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page48/E1/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page48/E1/8.jpg' },
                { url: 'img/FriendsPlus/Page48/E1/9.jpg', input: 4, },
                { url: 'img/FriendsPlus/Page48/E1/10.jpg', input: 5, isCorrect: true },
                { url: 'img/FriendsPlus/Page48/E1/11.jpg', input: 6, },
                { url: 'img/FriendsPlus/Page48/E1/12.jpg' },
                { url: 'img/FriendsPlus/Page48/E1/13.jpg', input: 7, },
                { url: 'img/FriendsPlus/Page48/E1/14.jpg', input: 8, isCorrect: true },
                { url: 'img/FriendsPlus/Page48/E1/15.jpg', input: 9, },
                { url: 'img/FriendsPlus/Page48/E1/16.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page48/E1/17.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page48/E1/18.jpg' },
                { url: 'img/FriendsPlus/Page48/E1/19.jpg', input: 10, },
                { url: 'img/FriendsPlus/Page48/E1/20.jpg', input: 11, isCorrect: true },
                { url: 'img/FriendsPlus/Page48/E1/21.jpg', input: 12, },
                { url: 'img/FriendsPlus/Page48/E1/22.jpg', input: 13, },
                { url: 'img/FriendsPlus/Page48/E1/23.jpg', input: 14, isCorrect: true },
                { url: 'img/FriendsPlus/Page48/E1/24.jpg', input: 15, },
                { url: 'img/FriendsPlus/Page48/E1/25.jpg' },
            ],
            [
                // Column7
                { url: 'img/FriendsPlus/Page48/E1/26.jpg' },
            ],

        ]
    },
    2: { // Exercise num
        unit: 'Unit 7',
        id: 'WB4-V2-U7-P48-E2',
        audio: '',
        video: '',
        component: D1,
        exerciseKey: 'img/FriendsPlus/Page48/E2/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page48/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page48/E2/2.jpg' },
                { url: 'img/FriendsPlus/Page48/E2/3.jpg', input: true, answer: "police station" },
                { url: 'img/FriendsPlus/Page48/E2/4.jpg' },
                { url: 'img/FriendsPlus/Page48/E2/5.jpg', input: true, answer: "airport" },
                { url: 'img/FriendsPlus/Page48/E2/6.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page48/E2/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page48/E2/8.jpg' },
                { url: 'img/FriendsPlus/Page48/E2/9.jpg', input: true, answer: "fire station" },
                { url: 'img/FriendsPlus/Page48/E2/10.jpg' },
                { url: 'img/FriendsPlus/Page48/E2/11.jpg', input: true, answer: "store" },
                { url: 'img/FriendsPlus/Page48/E2/12.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page48/E2/13.jpg' },
            ],


        ],
    },


}

export default json;